import CryptoJS from 'crypto-js';

  // Frontend encryption
export const  encryptPasswordAES = (password) => {
    const passwordKey = "E6t187^D43%F";
    const passwordBytes = CryptoJS.enc.Utf8.parse(passwordKey);
    const passwordHash = CryptoJS.SHA256(passwordBytes);
    
    const saltBytes = CryptoJS.lib.WordArray.create([0x01020304, 0x05060708]);
    const keyAndIv = CryptoJS.PBKDF2(
        passwordHash, 
        saltBytes,
        {
            keySize: (256 + 128) / 32,
            iterations: 1000,
            hasher: CryptoJS.algo.SHA1
        }
    );
    const key = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(0, 8)); 
    const iv = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(8, 12));
    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(password), 
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    
    return encrypted.toString();
}

// Decrypt a password encrypted with the above function
export const decryptPasswordAES = (encryptedBase64) => {
    // Fixed key and salt (must match encryption)
    const passwordKey = "E6t187^D43%F";
    const saltBytes = CryptoJS.lib.WordArray.create([0x01020304, 0x05060708]);

    // Step 1: Derive the same password hash (SHA256 of passwordKey)
    const passwordBytes = CryptoJS.enc.Utf8.parse(passwordKey);
    const passwordHash = CryptoJS.SHA256(passwordBytes);

    // Step 2: Derive key and IV via PBKDF2 (same parameters as encryption)
    const keyAndIv = CryptoJS.PBKDF2(
        passwordHash,
        saltBytes,
        {
            keySize: (256 + 128) / 32, // 12 words (48 bytes)
            iterations: 1000,
            hasher: CryptoJS.algo.SHA1
        }
    );

    // Split into 256-bit key (first 8 words) and 128-bit IV (next 4 words)
    const key = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(0, 8));
    const iv = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(8, 12));

    // Step 3: Decrypt the ciphertext
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // Convert to UTF-8 string
    return decrypted.toString(CryptoJS.enc.Utf8);
};